import { environment } from '../../../environments/environment';

export class URL {
  static readonly BASE_URL = environment.BASE_URL;
  static readonly IDENTITY_BASE_URL = environment.BASE_URL + '/token';
  static readonly ENV_URL = environment.ENV_URL;
}
